<template lang="pug">
  .dashboard-index-scene
    div.container.flex.items-start.pt4(v-if="!locations")
      loading
    div.container.flex.items-start.pt4(v-else)
      //- template(v-if="!locations")
      //- template(v-else)
      div.sidebar.mr5
        h1.f4.b.ma0 Locations
      div.locations
        ul.locationlist
          li.locationitem(v-for="{stations, name} in locations")
            h3.locationname.f5.mb3 {{name}}
            ul.stationlist.pl3
              li.stationitem.mb2(v-for="station in stations")
                router-link.stationname.f6.b.orange.pointer(target="_blank" :to="{ name: 'station-login', params: { stationId: station.id } }") {{station.title}}
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import Component from 'vue-class-component';
import Loading from '@/core/shared/components/Loading.vue';

@Component({
  computed: mapState({
    locations: state => state.dashboard.locations,
  }),
  components: {
    Loading,
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.$store.commit('resetLauncherState');
    });
  },
})
export default class Admin extends Vue {
  created () {
    this.$store.dispatch('getLocations');
  }
}
</script>

<style scoped>
@import "core/shared/styles";

.dashboard-index-scene {
  @apply --container;
  height: calc(100vh - 80px);
}
</style>
